module.exports = __webpack_public_path__ + "static/media/lapysteps.257dcfed.png";